module.exports = __webpack_public_path__ + "static/media/ruedas.3fb85518.png";